import { articleCollection, articleSlugCollection } from "#root/schema/article";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";

import { GlyphLoading } from "../components/glyphs";
import { Markdown } from "../components/markdown";
import PageLayout from "./layout";

export default function ArticlePage({ id }): ReactNode {
  const [details] = useData(async () => {
    if (/\D/.test(id)) {
      return articleSlugCollection.details(id);
    }

    return articleCollection.details(id);
  }, [id]);

  const { row } = details || {};

  if (!row) {
    return (
      <PageLayout title="Read Article">
        <GlyphLoading/>
      </PageLayout>
    );
  }

  return (
    <PageLayout title={row?.name}>
      <section>
        <h1>{row?.name}</h1>
        <Markdown markdown={row?.page}/>
      </section>
    </PageLayout>
  );
}
